/** Oyun davranışını yöneten sabitler — tek konfigürasyon noktası. */

/** Nokia 3310 LCD paleti. */
export const LCD = {
  bg: "#9bbb45",
  dark: "#20301a",
  mid: "#7ea53a",
  light: "#b3d165",
} as const;

export const FONT_FAMILY = '"Press Start 2P", monospace';

export interface Difficulty {
  key: "easy" | "medium" | "hard";
  label: string;
  /** Bir hücre ilerleme süresi (ms). */
  tick: number;
}

export const DIFFICULTIES: readonly Difficulty[] = [
  { key: "easy", label: "EASY", tick: 210 },
  { key: "medium", label: "MEDIUM", tick: 145 },
  { key: "hard", label: "HARD", tick: 92 },
];

/** Kademeli hız modu: her yemde bu kadar hızlanır, bu alt sınırın altına inmez (ms). */
export const PROGRESSIVE_STEP_MS = 4;
export const PROGRESSIVE_MIN_MS = 62;

/** Gamepad analog ölü bölge ve buton tekrar süreleri (ms). */
export const GAMEPAD = {
  deadZone: 0.5,
  repeatDelayMs: 350,
  repeatRateMs: 140,
} as const;

/** Xbox controller standart buton eşlemeleri (Gamepad API indeksleri). */
export const PAD_BUTTONS = {
  A: 0,
  B: 1,
  X: 2,
  Y: 3,
  LB: 4,
  RB: 5,
  LT: 6,
  RT: 7,
  BACK: 8,
  START: 9,
  DPAD_UP: 12,
  DPAD_DOWN: 13,
  DPAD_LEFT: 14,
  DPAD_RIGHT: 15,
} as const;

/** Yem başına puan. */
export const FOOD_SCORE = 10;

/** LCD tarama çizgisi dokusunun aralığı (px). */
export const SCANLINE_GAP_PX = 3;
